"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TrafficSpacesRowStyles = require("../../styles/TrafficSpacesRowStyles");

var _OrbitNetLabels = _interopRequireDefault(require("../Labels/OrbitNetLabels"));

var _TrafficAppointmentCard = _interopRequireDefault(require("./TrafficAppointmentCard"));

var _TrafficAppointmentConflicCard = _interopRequireDefault(require("./TrafficAppointmentConflicCard"));

var _utils = require("../../utils");

var _excluded = ["id", "range", "rowIndex", "available", "className", "tags", "appointments", "conflicts", "begin", "end", "loadManeuver", "unloadManeuver", "unloadLoadManeuver", "loadManeuverIcon", "unloadManeuverIcon", "unloadLoadManeuverIcon"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var spaceWidth = 100;

var TrafficSpacesRow = function TrafficSpacesRow(_ref) {
  var id = _ref.id,
      range = _ref.range,
      rowIndex = _ref.rowIndex,
      available = _ref.available,
      className = _ref.className,
      tags = _ref.tags,
      appointments = _ref.appointments,
      conflicts = _ref.conflicts,
      begin = _ref.begin,
      end = _ref.end,
      loadManeuver = _ref.loadManeuver,
      unloadManeuver = _ref.unloadManeuver,
      unloadLoadManeuver = _ref.unloadLoadManeuver,
      loadManeuverIcon = _ref.loadManeuverIcon,
      unloadManeuverIcon = _ref.unloadManeuverIcon,
      unloadLoadManeuverIcon = _ref.unloadLoadManeuverIcon,
      props = _objectWithoutProperties(_ref, _excluded);

  // Diff between end and begin of range
  var diffRanges = range[1] - range[0]; // Total of spaces

  var totalAvariableSpaces = (diffRanges + spaceWidth) / spaceWidth; // Size of one space

  var widthSpaces = spaceWidth / totalAvariableSpaces - 0; // List of spaces

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      spaces = _useState2[0],
      setSpaces = _useState2[1];

  var calculateWidthSpace = (0, _react.useCallback)(function (appointmentInterval) {
    return "".concat(widthSpaces * appointmentInterval / spaceWidth, "%");
  }, [widthSpaces]);

  var validateCardWithCurrentTime = function validateCardWithCurrentTime(spaceEnd) {
    // if (spaceEnd % spaceWidth !== 0) return false;
    return spaceEnd / spaceWidth <= new Date().getHours();
  };
  /**
   * @author: Juan de Dios
   * @description generate the spaces between begin and end range
   */


  (0, _react.useEffect)(function () {
    setSpaces(function (prev) {
      return [];
    });

    var _loop = function _loop(indexAppoint) {
      var appointment = appointments[indexAppoint]; // End value for last appointment

      var endLastAppointment = appointments[indexAppoint - 1] ? appointments[indexAppoint - 1].end : 0;
      var appointBeforeEnd = (0, _utils.convertTimeToWidthSpace)(endLastAppointment); // Range of one appointment

      var appointBegin = (0, _utils.convertTimeToWidthSpace)(appointment.begin);
      var appointEnd = (0, _utils.convertTimeToWidthSpace)(appointment.end); // Total space difference between the last appointment and current appointment

      var diffBetweenSpace = appointBegin - (appointBeforeEnd || 0);

      if (diffBetweenSpace > 0 && indexAppoint !== 0) {
        (function () {
          var width = calculateWidthSpace(diffBetweenSpace); // Total free spaces

          var totalFreeSpaces = diffBetweenSpace / spaceWidth;
          var freeSpace = {
            free: true,
            width: "".concat(widthSpaces, "%")
          };

          if (totalFreeSpaces >= 1) {
            var integerFreeSpaces = Math.trunc(totalFreeSpaces);
            var modFreeSpace = totalFreeSpaces - integerFreeSpaces;
            var modFreeSpaceEnd = appointBeforeEnd + modFreeSpace * spaceWidth;

            if (modFreeSpace > 0) {
              var unused = validateCardWithCurrentTime(modFreeSpaceEnd);
              setSpaces(function (prev) {
                return [].concat(_toConsumableArray(prev), [_objectSpread(_objectSpread({}, freeSpace), {}, {
                  width: "".concat(modFreeSpace * widthSpaces, "%"),
                  begin: appointBeforeEnd,
                  end: modFreeSpaceEnd,
                  margin: modFreeSpaceEnd % spaceWidth === 0 ? '0 0.2rem 0 0' : '0',
                  unused: unused
                })]);
              });
            }

            var _loop2 = function _loop2(space) {
              var currentFreeEndPosition = modFreeSpaceEnd + spaceWidth * space;
              var unused = validateCardWithCurrentTime(currentFreeEndPosition);
              setSpaces(function (prev) {
                return [].concat(_toConsumableArray(prev), [_objectSpread(_objectSpread({}, freeSpace), {}, {
                  margin: currentFreeEndPosition % spaceWidth === 0 ? '0 0.2rem 0 0' : '0',
                  begin: currentFreeEndPosition - spaceWidth,
                  end: currentFreeEndPosition,
                  unused: unused
                })]);
              });
            };

            for (var space = 1; space <= integerFreeSpaces; space++) {
              _loop2(space);
            }
          } else {
            var currentModFreeEndPosition = appointBeforeEnd + diffBetweenSpace;

            var _unused = validateCardWithCurrentTime(appointBeforeEnd);

            setSpaces(function (prev) {
              return [].concat(_toConsumableArray(prev), [_objectSpread(_objectSpread({}, freeSpace), {}, {
                width: width,
                margin: currentModFreeEndPosition % spaceWidth === 0 ? '0 0.2rem 0 0' : '0',
                end: appointBeforeEnd,
                unused: _unused
              })]);
            });
          }
        })();
      } // Total space in the current appointment


      var spaceAppointment = appointEnd - appointBegin;
      var width = calculateWidthSpace(spaceAppointment);
      setSpaces(function (prev) {
        return [].concat(_toConsumableArray(prev), [_objectSpread(_objectSpread({}, appointment), {}, {
          height: '100%',
          width: width,
          margin: appointEnd % spaceWidth === 0 ? '0 0.2rem 0 0' : '0',
          borderRadius: appointEnd % spaceWidth !== 0 && '0.2rem 0 0.2rem 0',
          borderRight: appointEnd % spaceWidth !== 0 && '1px gray solid'
        })]);
      });
    };

    for (var indexAppoint = 0; indexAppoint < appointments.length; indexAppoint++) {
      _loop(indexAppoint);
    }
  }, [spaces, appointments, calculateWidthSpace, widthSpaces]);
  /**
   * @author Juan de Dios
   * @description add the final free spaces
   */

  (0, _react.useEffect)(function () {
    var lastSpace = appointments[appointments.length - 1] || {
      end: 0
    };
    var endLastSpace = lastSpace.end;
    var remainSpace = end - ((0, _utils.convertTimeToWidthSpace)(endLastSpace) || 0);

    if (remainSpace === end) {
      remainSpace = (0, _utils.convertTimeToWidthSpace)(end) - (0, _utils.convertTimeToWidthSpace)(begin) + spaceWidth;
    }

    if (remainSpace > 0) {
      var totalFreeSpace = remainSpace / spaceWidth;
      var integerFreeSpace = Math.trunc(totalFreeSpace);
      var modFreeSpace = totalFreeSpace - integerFreeSpace;

      if (modFreeSpace > 0) {
        setSpaces(function (prev) {
          var endPrev = prev[prev.length - 1] ? prev[prev.length - 1].end : 0;
          var lastSpaceEnd = (0, _utils.convertTimeToWidthSpace)(endPrev) || 0;
          var unused = validateCardWithCurrentTime(lastSpaceEnd + modFreeSpace * spaceWidth);
          return [].concat(_toConsumableArray(prev), [{
            free: true,
            width: "".concat(widthSpaces * modFreeSpace, "%"),
            margin: '0 0.2rem 0 0',
            begin: lastSpaceEnd,
            end: lastSpaceEnd + modFreeSpace * spaceWidth,
            unused: unused
          }]);
        });
      }

      var _loop3 = function _loop3(space) {
        var currentFreeEndPosition = (0, _utils.convertTimeToWidthSpace)(lastSpace.end) + (spaceWidth * space + spaceWidth * modFreeSpace);
        setSpaces(function (prev) {
          var endPrev = prev[prev.length - 1] ? prev[prev.length - 1].end : 0;
          var lastSpaceEnd = (0, _utils.convertTimeToWidthSpace)(endPrev) || (0, _utils.convertTimeToWidthSpace)(begin);
          var unused = validateCardWithCurrentTime(lastSpaceEnd + spaceWidth);
          return [].concat(_toConsumableArray(prev), [{
            free: true,
            width: "".concat(widthSpaces, "%"),
            margin: currentFreeEndPosition % spaceWidth === 0 ? '0 0.2rem 0 0' : '0',
            end: lastSpaceEnd + spaceWidth,
            begin: lastSpaceEnd,
            unused: unused
          }]);
        });
      };

      for (var space = 1; space <= integerFreeSpace; space++) {
        _loop3(space);
      }
    }
  }, [spaces, appointments, begin, end, widthSpaces]);
  /**
   * @author Juan de Dios
   * @description add the initial free spaces
   */

  (0, _react.useEffect)(function () {
    if (appointments.length > 0) {
      var firstSpace = appointments[0];
      var remainSpace = (0, _utils.convertTimeToWidthSpace)(firstSpace.begin) - (0, _utils.convertTimeToWidthSpace)(begin);

      if (remainSpace > 0) {
        var totalFreeSpace = remainSpace / spaceWidth;
        var integerFreeSpace = Math.trunc(totalFreeSpace);
        var modFreeSpace = totalFreeSpace - integerFreeSpace;

        if (modFreeSpace > 0) {
          setSpaces(function (prev) {
            var beginPrev = prev[0] ? prev[0].begin : 0;
            var lastSpaceBegin = (0, _utils.convertTimeToWidthSpace)(beginPrev) || 0;
            var unused = validateCardWithCurrentTime(lastSpaceBegin);
            return [{
              free: true,
              width: "".concat(widthSpaces * modFreeSpace, "%"),
              begin: (0, _utils.convertTimeToWidthSpace)(begin) + integerFreeSpace * spaceWidth,
              end: lastSpaceBegin,
              margin: lastSpaceBegin % spaceWidth === 0 ? '0 0.2rem 0 0' : '0',
              unused: unused
            }].concat(_toConsumableArray(prev));
          });
        }

        var _loop4 = function _loop4(space) {
          setSpaces(function (prev) {
            var lastSpaceEnd = (0, _utils.convertTimeToWidthSpace)(begin) + spaceWidth * space;
            var unused = validateCardWithCurrentTime(lastSpaceEnd);
            return [{
              free: true,
              width: "".concat(widthSpaces, "%"),
              begin: lastSpaceEnd - spaceWidth,
              end: lastSpaceEnd,
              margin: lastSpaceEnd % spaceWidth === 0 ? '0 0.2rem 0 0' : '0',
              unused: unused
            }].concat(_toConsumableArray(prev));
          });
        };

        for (var space = integerFreeSpace; space >= 1; space--) {
          _loop4(space);
        }
      }
    }
  }, [spaces, appointments, begin, widthSpaces]);
  /**
   * @author Juan de Dios
   * @description calculate and add closed spaces
   */

  (0, _react.useEffect)(function () {
    var _range = _slicedToArray(range, 2),
        beginRange = _range[0],
        endRange = _range[1];

    var diffBetweenBeginRange = beginRange - begin;

    if (diffBetweenBeginRange > 0) {
      throw new Error('the begin of space should be greater at of the begin of range');
    }

    var beginFreeSpaces = Math.abs(diffBetweenBeginRange) / spaceWidth;

    for (var space = 1; space <= beginFreeSpaces; space++) {
      setSpaces(function (prev) {
        return [{
          close: true,
          margin: '0 0.2rem 0 0',
          width: "".concat(widthSpaces, "%")
        }].concat(_toConsumableArray(prev));
      });
    }

    var diffBetweenEndRange = endRange - end;

    if (diffBetweenEndRange < 0) {
      throw new Error('the end of space should be less at of the end of range');
    }

    var endFreeSpaces = Math.abs(diffBetweenEndRange) / spaceWidth;

    for (var _space = 1; _space <= endFreeSpaces; _space++) {
      setSpaces(function (prev) {
        var lastSpaceEnd = prev[prev.length - 1] ? prev[prev.length - 1].end : 0;
        return [].concat(_toConsumableArray(prev), [{
          close: true,
          margin: '0 0.2rem 0 0',
          width: "".concat(widthSpaces, "%"),
          end: lastSpaceEnd + spaceWidth
        }]);
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [spaces, begin, end, widthSpaces]);
  /**
   * @author Juan de Dios
   * @description added remains closed card
   */

  (0, _react.useEffect)(function () {
    var _range2 = _slicedToArray(range, 2),
        endRange = _range2[1];

    if (spaces[spaces.length - 1] && (0, _utils.convertTimeToWidthSpace)(spaces[spaces.length - 1].end) === (0, _utils.convertTimeToWidthSpace)(endRange)) {
      setSpaces(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          close: true,
          margin: '0 0.2rem 0 0',
          width: "".concat(widthSpaces, "%")
        }]);
      });
    }
  }, [range, spaces, widthSpaces]);
  /**
   * @author Juan de Dios
   * @description add conflic cards
   */

  (0, _react.useEffect)(function () {
    var conflictsRow = [];

    for (var conflictIndex = 0; conflictIndex < conflicts.length; conflictIndex++) {
      var _conflicts$conflictIn = conflicts[conflictIndex],
          conflictBegin = _conflicts$conflictIn.begin,
          conflictEnd = _conflicts$conflictIn.end;
      var conflictSpaces = [];

      for (var spaceIndex = 0; spaceIndex < spaces.length; spaceIndex++) {
        var _spaces$spaceIndex = spaces[spaceIndex],
            spaceBegin = _spaces$spaceIndex.begin,
            spaceEnd = _spaces$spaceIndex.end;

        if (spaceBegin >= (0, _utils.convertTimeToWidthSpace)(conflictBegin) && spaceEnd <= (0, _utils.convertTimeToWidthSpace)(conflictEnd)) {
          conflictSpaces.push(_objectSpread(_objectSpread({
            index: spaceIndex
          }, spaces[spaceIndex]), {}, {
            conflict: conflicts[conflictIndex]
          }));
        }
      }

      conflictsRow.push(conflictSpaces);
    }

    var _loop5 = function _loop5(conflictRowIndex) {
      var conflictRow = conflictsRow[conflictRowIndex];

      if (conflictRow.length > 0) {
        setSpaces(function (prev) {
          var conflictEnd = (0, _utils.convertTimeToWidthSpace)(conflictRow[0].conflict.end);
          var conflictBegin = (0, _utils.convertTimeToWidthSpace)(conflictRow[0].conflict.begin);
          var width = calculateWidthSpace(conflictEnd - conflictBegin);
          prev.splice(conflictRow[0].index, conflictRow.length, _objectSpread({
            conflict: true,
            width: width,
            margin: conflictEnd % spaceWidth === 0 ? '0 0.2rem 0 0' : '0'
          }, conflictRow[0].conflict));
          return prev;
        });
      }
    };

    for (var conflictRowIndex = 0; conflictRowIndex < conflictsRow.length; conflictRowIndex++) {
      _loop5(conflictRowIndex);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [spaces]);
  return /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowStyles.Wrapper, _extends({
    className: className
  }, props), /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowStyles.LabelColumn, null, /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowStyles.CounterWrapper, null, rowIndex), /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowStyles.LabelWrapper, null, /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowStyles.ManouverWrapper, null, loadManeuver && loadManeuverIcon, unloadManeuver && unloadManeuverIcon, unloadLoadManeuver && unloadLoadManeuverIcon), /*#__PURE__*/_react["default"].createElement(_OrbitNetLabels["default"], {
    type: "multiple",
    textColor: "#436EA9",
    labels: tags
  }))), /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowStyles.SpaceWrapper, null, spaces.map(function (space, i) {
    return space.conflict ?
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    _react["default"].createElement(_TrafficAppointmentConflicCard["default"], _extends({}, space, {
      key: i
    })) :
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    _react["default"].createElement(_TrafficAppointmentCard["default"], _extends({}, space, {
      key: i
    }));
  })));
};

TrafficSpacesRow.propTypes = {
  id: _propTypes["default"].number,
  rowIndex: _propTypes["default"].number,
  range: _propTypes["default"].arrayOf(_propTypes["default"].number),
  loadManeuver: _propTypes["default"].bool,
  unloadManeuver: _propTypes["default"].bool,
  unloadLoadManeuver: _propTypes["default"].bool,
  loadManeuverIcon: _propTypes["default"].any,
  unloadManeuverIcon: _propTypes["default"].any,
  unloadLoadManeuverIcon: _propTypes["default"].any,
  begin: _propTypes["default"].number.isRequired,
  end: _propTypes["default"].number.isRequired,
  available: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  tags: _propTypes["default"].arrayOf(_propTypes["default"].exact({
    id: _propTypes["default"].number,
    description: _propTypes["default"].string,
    color: _propTypes["default"].string
  })),
  appointments: _propTypes["default"].arrayOf(_propTypes["default"].exact({
    id: _propTypes["default"].number,
    icon: _propTypes["default"].any,
    expClass: _propTypes["default"].string,
    level: _propTypes["default"].number,
    begin: _propTypes["default"].number,
    end: _propTypes["default"].number,
    className: _propTypes["default"].string,
    color: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  })),
  conflicts: _propTypes["default"].arrayOf(_propTypes["default"].exact({
    icon: _propTypes["default"].any,
    begin: _propTypes["default"].number,
    end: _propTypes["default"].number,
    className: _propTypes["default"].string,
    caption: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    conflictingIds: _propTypes["default"].arrayOf(_propTypes["default"].number),
    color: _propTypes["default"].string
  }))
};
TrafficSpacesRow.defaultProps = {
  id: null,
  loadManeuver: false,
  unloadManeuver: false,
  unloadLoadManeuver: false,
  loadManeuverIcon: null,
  unloadManeuverIcon: null,
  unloadLoadManeuverIcon: null,
  range: [600, 1900],
  available: true,
  className: null,
  tags: [],
  appointments: [],
  conflicts: []
};
var _default = TrafficSpacesRow;
exports["default"] = _default;